//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-288921 remove this once the feature is ready
export const getIsSamplingTargetedRetailerEnabled = createHasFeatureSelector(
  FeatureNames.SamplingTargetedRetailer,
);
